import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, LogIn, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const [email, setEmail] = useState("admin@gensrealty.com");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      toast.success("Welcome back");
      nav("/admin");
    } else {
      toast.error(res.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen relative bg-[#F9F6F0] flex items-center justify-center px-6">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1649083048381-520a5b3d91ff')",
        }}
      />
      <div className="absolute inset-0 bg-[#F9F6F0]/85" />

      <div className="relative z-10 w-full max-w-md">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs text-[#6B7280] hover:text-[#1E3B2F] mb-6"
          data-testid="back-to-home-link"
        >
          <ArrowLeft size={12} /> Back to home
        </Link>
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-[#EBE4D3]">
          <span className="font-label text-[10px] text-[#C25934]">Staff Portal</span>
          <h1 className="font-serif-display text-3xl text-[#1E3B2F] mt-2">Sign in</h1>
          <p className="text-sm text-[#6B7280] mt-1">
            Access the Gentry admin dashboard.
          </p>

          <form onSubmit={submit} className="mt-8 space-y-5">
            <div className="space-y-2">
              <label className="font-label text-[10px] text-[#6B7280]">Email</label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="h-11 bg-[#F9F6F0] border-[#EBE4D3]"
                data-testid="admin-login-email-input"
                required
              />
            </div>
            <div className="space-y-2">
              <label className="font-label text-[10px] text-[#6B7280]">Password</label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="h-11 bg-[#F9F6F0] border-[#EBE4D3]"
                data-testid="admin-login-password-input"
                required
              />
            </div>
            <Button
              type="submit"
              disabled={submitting}
              className="w-full h-11 bg-[#1E3B2F] hover:bg-[#294d3f] text-white btn-lift"
              data-testid="admin-login-submit"
            >
              {submitting ? (
                <Loader2 size={16} className="animate-spin" />
              ) : (
                <span className="flex items-center gap-2">
                  <LogIn size={14} /> Sign in
                </span>
              )}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
